import { currentLanguage } from "../../../algorithms/storage";
import axios from "../../axiosConfig";

export const getPosts = (communityId = 6, pageNo = 1, pageCount = 5, token) => {
  return axios.get(`Forum/GetForums/${communityId}/${pageNo}/${pageCount}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const searchPosts = (
  communityId,
  pageNumber = 1,
  pageSize = 5,
  data = {},
  token
) => {
  return axios.post(
    `Forum/Search/${communityId}/${pageNumber}/${pageSize}`,
    data,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
export const postsOfMonth = (
  communityId,
  pageNumber = 1,
  pageSize = 5,
  token
) => {
  return axios.get(
    `Forum/GetCurrentForum/${communityId}/${pageNumber}/${pageSize}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const addPostData = (body, token) => {
  return axios.post(`Forum/AddForum`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addCommentData = (body, token) => {
  return axios.post(`Forum/AddForumComment`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getPostData = (id, token) => {
  return axios.get(`Forum/GetForum/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const addReplyData = (body, token) => {
  return axios.post(`Forum/AddForumReply`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteForum = (forumId, token) => {
  return axios.delete(`Forum/DeleteForum/${forumId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getEditForum = (forumId, token) => {
  return axios.get(`Forum/EditForum/${forumId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editForum = (data = {}, token) => {
  return axios.put(`Forum/EditForum`, data, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
